import { render, staticRenderFns } from "./InvitationEdit.vue?vue&type=template&id=f02311a8&scoped=true&"
import script from "./InvitationEdit.vue?vue&type=script&lang=js&"
export * from "./InvitationEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f02311a8",
  null
  
)

export default component.exports